import React from "react";
import { Card, Row } from "antd";

import Description from "./Description";

const ProQqNew2 = ({ proinfo, title }) => {
  const data = proinfo || {};
  return (
    <Card title="产品明细">
      <h3 className="order_pro_title">{title}</h3>
      <div style={{ paddingLeft: "50px" }}>
        <Row>
          <Description term="400套餐企业QQ号码">
            {data.bq400_account}
          </Description>
          <Description term="400套餐类型">{data.bq400v}</Description>
          <Description term="400套餐工号数">{data.bq400_enum}</Description>
        </Row>
        <Row>
          <Description term="400套餐购买年限">{data.bq400_year}</Description>
          <Description term="400套餐赠送年限">{data.bq400_free}</Description>
          <Description term="400套餐服务费">{data.bq400_money}</Description>
        </Row>
        <Row>
          <Description term="800套餐企业QQ号码">
            {data.bq800_account}
          </Description>
          <Description term="800套餐类型">{data.bq800v}</Description>
          <Description term="800套餐工号数">{data.bq800_enum}</Description>
        </Row>
        <Row>
          <Description term="800套餐购买年限">{data.bq800_year}</Description>
          <Description term="800套餐赠送年限">{data.bq800_free}</Description>
          <Description term="800套餐服务费">{data.bq800_money}</Description>
        </Row>
        <Row>
          <Description term="办公企业QQ套餐类型">{data.bqv}</Description>
          <Description term="办公企业QQ开头">{data.bqh}</Description>
          <Description term="办公企业QQ工号数">{data.bq_enum}</Description>
        </Row>
        <Row>
          <Description term="办公企业QQ购买年限">{data.bq_year}</Description>
          <Description term="800套餐赠送年限">{data.bq_free}</Description>
          <Description term="办公企业QQ送年限">{data.bq800_money}</Description>
        </Row>
        <Row>
          <Description term="办公企业QQ服务费">{data.bq_money}</Description>
          <Description term="增值服务群发充值">{data.ad_money}</Description>
          <Description term="增值服务短信充值">{data.msg_message}</Description>
        </Row>
        <Row>
          <Description term="增值服务离线消息转发">
            {data.offmsg_money}
          </Description>
          <Description term="增值服务微信认证">{data.weixin_money}</Description>
          <Description term="邮箱版本">{data.email_version}</Description>
        </Row>
        <Row>
          <Description term="邮箱用户数">{data.email_num}</Description>
          <Description term="邮箱购买年限">{data.email_year}</Description>
          <Description term="邮箱服务费">{data.email_money}</Description>
        </Row>
        <Row>
          <Description term="更换版本原号码">{data.bq_old_account}</Description>
          <Description term="更换版本原版本">{data.bq_oldv}</Description>
          <Description term="更换版本工号数">{data.bq_old_enum}</Description>
        </Row>
        <Row>
          <Description term="更换版本购买年限">{data.bq_old_year}</Description>
          <Description term="更换版本现号码">{data.bq_new_account}</Description>
          <Description term="更换版本现版本">{data.bq_newv}</Description>
        </Row>
        <Row>
          <Description term="更换版本工号数">{data.bq_new_enum}</Description>
          <Description term="更换版本购买年限">{data.bq_new_year}</Description>
          <Description term="更换版本更换金额">
            {data.bq_change_money}
          </Description>
        </Row>
      </div>
    </Card>
  );
};

export default ProQqNew2;



// WEBPACK FOOTER //
// ./src/components/xianxing/order/ProQqNew2.js